module.exports = __webpack_public_path__ + "static/rowIcon4.ff39d240.svg";